<template>
  <div>
    <div class="page-title-container lighter-shadow">
      <i class="fas fa-user-lock icon"></i>
      <h1>Списък на потребители</h1>
      <LiteButton class="add-button"
                  v-if="isUserSuperAdmin"
                  @click.native="addUserClicked"
                  :hoverColor="'green'"
                  :icon="'far fa-plus-square'"
                  :text="'Добавяне на потребител'">
      </LiteButton>
    </div>
    <Grid class="grid"
          :config="config"
          :gridData="gridData"
          :loading="isLoading"
          @row-clicked="rowClicked">
    </Grid>
  </div>
</template>

<script>
import Grid from "@/shared/components/grid/Grid";
import userListGridConfig from "@/components/user/user-list-grid.config";
import redirectService from "@/services/redirect.service";
import autorizationService from "@/services/authorization.service";
import {mapGetters} from "vuex";
import LiteButton from "@/shared/components/button/LiteButton";

export default {
  name: "UserList",
  components: {LiteButton, Grid},
  created() {
    autorizationService.getUsers()
        .then(({data}) => {
          if (data) {
            this.gridData = data;
            this.isLoading = false;
          }
        });
  },
  data() {
    return {
      config: userListGridConfig,
      gridData: [],
      isLoading: true
    }
  },
  methods: {
    rowClicked(row) {
      redirectService.redirectToUserInfo(row.id);
    },
    addUserClicked() {
      redirectService.redirectToAddUser();
    }
  },
  computed: {
    ...mapGetters(['isUserSuperAdmin'])
  }
}
</script>

<style scoped>
.add-button {
  width: 350px;
  float: right;
  margin: 35px 0;
  font-size: 25px;
  color: var(--primary-blue);
}

.grid {
  margin-top: 30px;
  display: inline-block;
}
</style>
